import React from 'react';

import { Heading, VStack } from '@rtkwlf/fenrir-react';
import type { AttachmentFile } from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';

import { TicketEvents } from './TicketEvents';

type TicketEvidenceNavigatorProps = {
  ticketId: string;
  attachments: Array<AttachmentFile>;
};

export const csvType = '.csv';

export const TicketEvidenceNavigator: React.FC<
  TicketEvidenceNavigatorProps
> = ({ ticketId, attachments }) => {
  const { t } = useTranslation();

  if (!Array.isArray(attachments) || attachments.length === 0) {
    return null;
  }

  return (
    <VStack marginTop="default" width="full" overflow="auto">
      <Heading level="3">{t('ticket:evidenceNavigator.title')}</Heading>

      {attachments.map(({ id = '', name = '' }) => (
        <React.Fragment key={id}>
          {attachments.length > 1 ? (
            <Heading level="4" marginBottom="default">
              {name.replace(csvType, '')}
            </Heading>
          ) : null}

          <TicketEvents ticketId={ticketId} attachmentId={id.toString()} />
        </React.Fragment>
      ))}
    </VStack>
  );
};
